"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateMultiLineText = exports.serializeMultiLineText = void 0;
const serializeMultiLineText = (item) => {
    return typeof item.data.text === "string" ? item.data.text : "";
};
exports.serializeMultiLineText = serializeMultiLineText;
const validateMultiLineText = (item) => {
    if (!item.required || item.data.text) {
        return { valid: true };
    }
    return { valid: false, error: { message: "Must be filled out." } };
};
exports.validateMultiLineText = validateMultiLineText;
//# sourceMappingURL=multiLineText.js.map